import { render, staticRenderFns } from "./MenuLevel2.vue?vue&type=template&id=28633023&scoped=true&"
import script from "./MenuLevel2.vue?vue&type=script&lang=js&"
export * from "./MenuLevel2.vue?vue&type=script&lang=js&"
import style0 from "./MenuLevel2.vue?vue&type=style&index=0&id=28633023&prod&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28633023",
  null
  
)

export default component.exports